/* ============================================
   ESCOSY — Theme JavaScript  v1.1
   QA Fixes:
   #003 Sticky ATB via IntersectionObserver
   #004 Reveal IO not created inside scroll
   #006 Null-safe all listeners
   #007 Cart bubble count via /cart.js
   #008 Dynamic copyright year
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── FIX #008 Dynamic copyright year ──
  var yr = new Date().getFullYear();
  document.querySelectorAll('[data-year]').forEach(function (el) { el.textContent = yr; });

  // Respect reduced-motion preferences, including optional autoplay hero video.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('video[autoplay]').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  // ── 1. Scroll Reveal — content remains visible when JS/IO is unavailable ──
  var revealIO = null;
  if ('IntersectionObserver' in window) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
  }
  function observeReveals() {
    document.querySelectorAll('[data-reveal]:not(.reveal-ready):not(.is-visible)').forEach(function (el) {
      if (!revealIO) {
        el.classList.add('is-visible');
        return;
      }
      el.classList.add('reveal-ready');
      revealIO.observe(el);
    });
  }
  observeReveals();
  document.addEventListener('shopify:section:load', observeReveals);

  // ── 2. Header scroll ──
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () { header.classList.toggle('is-scrolled', window.scrollY > 40); }, { passive: true });
  }

  // ── 3. Announcement bar close ──
  var annClose = document.querySelector('.announcement-bar__close');
  if (annClose) {
    annClose.addEventListener('click', function () {
      var bar = document.querySelector('.announcement-bar');
      if (!bar) return;
      bar.style.cssText = 'height:' + bar.offsetHeight + 'px;overflow:hidden;';
      requestAnimationFrame(function () {
        bar.style.transition = 'height .3s,padding .3s,opacity .3s';
        bar.style.height = '0'; bar.style.paddingTop = '0'; bar.style.paddingBottom = '0'; bar.style.opacity = '0';
      });
      setTimeout(function () { bar.style.display = 'none'; }, 320);
      try { sessionStorage.setItem('escosy_ann', '1'); } catch(e) {}
    });
    try { if (sessionStorage.getItem('escosy_ann')) { var b = document.querySelector('.announcement-bar'); if (b) b.style.display = 'none'; } } catch(e) {}
  }

  // ── 4. Mobile Nav Drawer ──
  function initMobileNav() {
    var drawer = document.getElementById('NavDrawer');
    var openBtn = document.querySelector('.mobile-menu-btn');
    if (!drawer || !openBtn) return;

    // Keep drawer at document root so fixed positioning is viewport-based
    // even when section wrappers use CSS transforms.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    drawer.inert = !drawer.classList.contains('open');

    function getOpenBtn() {
      return document.querySelector('.mobile-menu-btn');
    }

    function openNav() {
      if (drawer.classList.contains('open')) return;
      var btn = getOpenBtn();
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('open');
      document.body.classList.add('nav-open');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'Close menu');
      }
      window.requestAnimationFrame(function () {
        var firstControl = drawer.querySelector('.nav-drawer__close, .nav-drawer__links a');
        if (firstControl) firstControl.focus();
      });
    }

    function closeNav(restoreFocus) {
      if (!drawer.classList.contains('open')) return;
      var btn = getOpenBtn();
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      document.body.classList.remove('nav-open');
      if (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Open menu');
        if (restoreFocus && document.contains(btn)) btn.focus();
      }
    }

    function toggleNav() {
      if (drawer.classList.contains('open')) {
        closeNav(true);
      } else {
        openNav();
      }
    }

    if (openBtn.dataset.navInit !== 'true') {
      openBtn.dataset.navInit = 'true';
      openBtn.addEventListener('click', toggleNav);
    }

    if (drawer.dataset.navInit === 'true') return;
    drawer.dataset.navInit = 'true';

    var closeBtn = drawer.querySelector('.nav-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { closeNav(true); });

    var backdrop = drawer.querySelector('.nav-drawer__backdrop');
    if (backdrop) backdrop.addEventListener('click', function () { closeNav(true); });

    drawer.querySelectorAll('.nav-drawer__links a').forEach(function (link) {
      link.addEventListener('click', function () { closeNav(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('open')) return;
      if (e.key === 'Escape') {
        closeNav(true);
        return;
      }
      if (e.key !== 'Tab') return;

      var focusable = Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    });

    // Touch swipe-left to close drawer
    var touchStartX = 0;
    drawer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    drawer.addEventListener('touchend', function (e) {
      if (e.changedTouches[0].clientX - touchStartX < -60) closeNav(true);
    }, { passive: true });
  }
  initMobileNav();
  document.addEventListener('shopify:section:load', initMobileNav);

  // ── 5. Product Gallery Thumbs ──
  function initProductGalleries(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryInit === 'true') return;
      gallery.dataset.galleryInit = 'true';

      var mediaPanels = gallery.querySelectorAll('[data-product-media]');
      var thumbs = gallery.querySelectorAll('.product-gallery__thumb');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var targetId = thumb.dataset.mediaTarget;
          var target = targetId ? document.getElementById(targetId) : null;
          if (!target || !gallery.contains(target)) return;

          mediaPanels.forEach(function (panel) {
            panel.hidden = panel !== target;
            if (panel !== target) {
              panel.querySelectorAll('video').forEach(function (video) { video.pause(); });
            }
          });

          thumbs.forEach(function (item) {
            var isCurrent = item === thumb;
            item.classList.toggle('is-active', isCurrent);
            item.setAttribute('aria-current', String(isCurrent));
          });
        });
      });
    });
  }
  initProductGalleries(document);
  document.addEventListener('shopify:section:load', function (event) {
    initProductGalleries(event.target);
  });

  // ── 6. Product variants + qty stepper ──
  function initProductForm() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    // Initialize qty stepper once.
    var qtyInput = form.querySelector('[data-qty-input]');
    if (qtyInput && qtyInput.dataset.qtyInit !== 'true') {
      qtyInput.dataset.qtyInit = 'true';
      function clampQtyInput() {
        var next = parseInt(qtyInput.value, 10);
        if (isNaN(next)) next = 1;
        qtyInput.value = String(Math.max(1, Math.min(99, next)));
      }
      qtyInput.addEventListener('input', clampQtyInput);
      clampQtyInput();
      form.querySelectorAll('[data-qty-stepper]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(qtyInput.value, 10);
          if (isNaN(current)) current = 1;
          if (btn.dataset.qtyStepper === 'minus') {
            current = Math.max(1, current - 1);
          } else {
            current = Math.min(99, current + 1);
          }
          qtyInput.value = String(current);
        });
      });
    }

    // If the product has only one variant, qty logic above is all we need.
    var variantDataEl = document.getElementById('ProductVariantData');
    var optionGroups = form.querySelectorAll('.variant-pills[data-option-position]');
    if (!variantDataEl || optionGroups.length === 0) return;
    if (form.dataset.variantInit === 'true') return;
    form.dataset.variantInit = 'true';

    var variants = [];
    try {
      variants = JSON.parse(variantDataEl.textContent || '[]');
    } catch (err) {
      variants = [];
    }
    if (!variants.length) return;

    var idInput = document.getElementById('VariantIdInput');
    var priceEl = document.getElementById('ProductPrice');
    var compareEl = document.getElementById('ProductComparePrice');
    var saveBadge = document.getElementById('ProductSaveBadge');
    var stickyPrice = document.getElementById('StickyPrice');
    var atbBtn = document.getElementById('AddToCartBtn');
    var stickyBtn = document.getElementById('StickyATBBtn');

    function getSelectedOptions() {
      return Array.prototype.map.call(optionGroups, function (group) {
        var active = group.querySelector('.variant-pill.is-active');
        return active ? active.dataset.optionValue : '';
      });
    }

    function findMatchingVariant(selectedOptions) {
      for (var i = 0; i < variants.length; i += 1) {
        var variant = variants[i];
        var matched = true;
        for (var j = 0; j < selectedOptions.length; j += 1) {
          if (variant.options[j] !== selectedOptions[j]) {
            matched = false;
            break;
          }
        }
        if (matched) return variant;
      }
      return null;
    }

    function updateVariantUI(variant) {
      if (!variant) {
        if (idInput) idInput.value = '';
        if (atbBtn) {
          atbBtn.disabled = true;
          atbBtn.setAttribute('aria-disabled', 'true');
          atbBtn.textContent = 'Unavailable';
        }
        if (stickyBtn) {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = String(variant.id);
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;

      if (compareEl) {
        if (variant.compare) {
          compareEl.textContent = variant.compare;
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (saveBadge) {
        var hasCompare = variant.compareCents && variant.compareCents > variant.priceCents;
        if (hasCompare) {
          var saving = Math.round(((variant.compareCents - variant.priceCents) * 100) / variant.compareCents);
          saveBadge.textContent = 'Save ' + saving + '%';
          saveBadge.style.display = '';
        } else {
          saveBadge.style.display = 'none';
        }
      }

      if (atbBtn) {
        atbBtn.disabled = !variant.available;
        atbBtn.setAttribute('aria-disabled', String(!variant.available));
        atbBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }

      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
    }

    function syncVariantFromPills() {
      updateVariantUI(findMatchingVariant(getSelectedOptions()));
    }

    Array.prototype.forEach.call(optionGroups, function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.variant-pill');
        if (!pill || pill.disabled) return;
        group.querySelectorAll('.variant-pill').forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-pressed', 'true');
        syncVariantFromPills();
      });
    });

    syncVariantFromPills();
  }
  initProductForm();
  document.addEventListener('shopify:section:load', initProductForm);

  // ── 7. FIX #003 Sticky ATB — IntersectionObserver only, no setTimeout ──
  var stickyBar = document.getElementById('StickyATB');
  var mainATB   = document.getElementById('AddToCartBtn');
  if (stickyBar && mainATB) {
    var stickyBtn = document.getElementById('StickyATBBtn');
    if (stickyBtn) stickyBtn.setAttribute('tabindex', '-1');
    var stickyIO = new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      stickyBar.classList.toggle('visible', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
      if (stickyBtn) {
        if (show) {
          stickyBtn.removeAttribute('tabindex');
        } else {
          stickyBtn.setAttribute('tabindex', '-1');
        }
      }
    }, { rootMargin: '-80px 0px 0px 0px' });
    stickyIO.observe(mainATB);
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (mainATB) mainATB.click(); });
  }

  // ── 8. Accordions — FIX #006 null-safe ──
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var acc = this.closest('.accordion');
      if (!acc) return;
      var wasOpen = acc.classList.contains('is-open');
      var parent = acc.parentElement;
      if (parent) parent.querySelectorAll('.accordion.is-open').forEach(function (a) { a.classList.remove('is-open'); var t = a.querySelector('.accordion__trigger'); if (t) t.setAttribute('aria-expanded', 'false'); });
      acc.classList.toggle('is-open', !wasOpen);
      this.setAttribute('aria-expanded', String(!wasOpen));
    });
  });

  // ── 9. AJAX Add to Cart ──
  document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) { alert(data.description || 'Error adding to cart.'); if (btn) { btn.disabled = false; btn.textContent = orig; } return; }
        // FIX #007 — fetch real count
        fetch(shopRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var cartLink = document.querySelector('[data-cart-link]');
          var bubble = document.querySelector('.cart-bubble');
          if (bubble) { bubble.textContent = cart.item_count; bubble.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
          if (cartLink) {
            cartLink.setAttribute('aria-label', 'Cart (' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')');
          }
          var toastLink = document.querySelector('.cart-notification__sub a');
          if (toastLink) toastLink.textContent = 'View cart (' + cart.item_count + ')';
        });
        showToast(data.title || 'Added to bag');
        if (btn) { btn.textContent = '✓ Added!'; btn.style.background = '#2d7d4e'; setTimeout(function () { btn.disabled = false; btn.textContent = orig; btn.style.background = ''; }, 2200); }
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
    });
  });

  function showToast(title) {
    var notif = document.querySelector('.cart-notification');
    if (!notif) return;
    var t = notif.querySelector('.cart-notification__text');
    if (t) t.textContent = title;
    notif.classList.add('visible');
    clearTimeout(notif._t);
    notif._t = setTimeout(function () { notif.classList.remove('visible'); }, 3500);
  }
  var toast = document.querySelector('.cart-notification');
  if (toast) toast.addEventListener('click', function () { this.classList.remove('visible'); });

  // ── 9.1 Collection sort (query-safe, no inline JS needed) ──
  var collectionSort = document.getElementById('CollectionSort');
  if (collectionSort) {
    collectionSort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ── 10. Cart page qty ──
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = this.closest('.cart-item__qty');
      if (!wrap) return;
      var input = wrap.querySelector('.qty-input');
      if (!input) return;
      var newVal = this.dataset.action === 'minus' ? Math.max(0, (parseInt(input.value) || 1) - 1) : (parseInt(input.value) || 0) + 1;
      input.value = newVal;
      if (input.dataset.lineKey) {
        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(shopRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.dataset.lineKey, quantity: newVal }) })
          .then(function () { window.location.reload(); });
      }
    });
  });

  // ── 11. Warranty form ──
  var wForm = document.getElementById('WarrantyForm');
  if (wForm) wForm.addEventListener('submit', function () { var b = this.querySelector('.form-submit'); if (b) { b.disabled = true; b.textContent = 'Submitting…'; } });

});
